import React from 'react';
import { FormattedMessage } from 'react-intl';

import AccordionList from 'components/accordion-list';

import 'swiper/swiper.scss';
import './styles.scss';

const Faqs = [
  {
    title: 'transporter.faqs.f1.title',
    description: 'transporter.faqs.f1.description'
  },
  {
    title: 'transporter.faqs.f2.title',
    description: 'transporter.faqs.f2.description'
  },
  {
    title: 'transporter.faqs.f3.title',
    description: 'transporter.faqs.f3.description'
  },
  {
    title: 'transporter.faqs.f4.title',
    description: 'transporter.faqs.f4.description'
  }
];

const BeCarrierFaq = () => {
  const faqs = Faqs;

  return (
    <div className="be-carrier-faq">
      <div className="container">
        <h6 className="be-carrier-faq__title">
          <FormattedMessage id="transporter.faqs.title" />
        </h6>
        <h1 className="h1--display be-carrier-faq__description">
          <FormattedMessage id="transporter.faqs.description" />
        </h1>
        <div className="row justify-content-center">
          <div className="col col-12 col-lg-8 col-xl-6">
            <AccordionList
              list={faqs}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeCarrierFaq;
